<template>
    <div>
        <rkm-form
            v-if="loaded"
            ref="Form"
        >
            <rkm-tabs
                v-model="tabIndex"
            >
                <rkm-tab
                    active
                    title="Geral"
                >
                    <TabGeral
                        ref="TabGeral"
                        :form="form"
                        :model="model"
                    />
                </rkm-tab>

                <rkm-tab
                    title="Faturamento"
                >
                    <TabFaturamento
                        ref="TabFaturamento"
                        :form="form"
                        :model="model"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>

// Components.
import TabGeral from './components/geral/Form'
import TabFaturamento from './components/faturamento/Form'

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        TabGeral,
        TabFaturamento,
    },
    created() {

        this.repositories.parametrizacao = this.getConectaSusRepository('transportePaciente.parametrizacao')

        this.load()
    },
    data: () => ({
        repositories: {
            parametrizacao: null,
        },
        form: [],
        model: [],
        tabIndex: 0,
        tabRefs: [],
        loaded: false
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.setData(data.form || null, data.model || null)

                    this.loaded = true

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabGeral,
                            this.$refs.TabFaturamento,
                        ]
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
            }
        },
        save() {

            this.setLoading()

            this.repositories.parametrizacao.store(this.prepareData())
                .then(({ data }) => {

                    this.showSaveNotification()
                    this.$emit('save', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const geral = {
                faltas: this.model.faltas,
                periodo: this.model.periodo,
                horarioSaida: this.model.horarioSaida,
                faturamento: this.model.faturamento,
                auxilioAlimentacao: this.model.auxilioAlimentacao,
                agendarTransporteJornada: this.model.agendarTransporteJornada,
                mensagemProtocolo: this.model.mensagemProtocolo,
                veiculo: this.model.veiculo,
                comprovanteAcompanhante: this.model.comprovanteAcompanhante,
                dadosAcompanhante: this.model.dadosAcompanhante,
                campoLivre: this.model.campoLivre,
                exibirObservacaoPaciente: this.model.exibirObservacaoPaciente,
                exibirObservacaoTransporte: this.model.exibirObservacaoTransporte,
            }

            const faturamento = this.model.faturamentos.map(faturamento => ({
                unidadeId: faturamento.unidadeId,
                infraestruturaId: faturamento.infraestruturaId,
                usuarioId: faturamento.usuarioId,
                ocupacaoId: faturamento.ocupacaoId,
                padrao: faturamento.padrao ?? false,
                ativo: faturamento.ativo ?? true,
            }))

            const classificacaoCadastro = this.model.classificacaoCadastro

            const integracaoAplicativo = this.model.integracaoAplicativo

            return this.camelObjectKeysToSnakeRecursive({
                geral, classificacaoCadastro, integracaoAplicativo, faturamento,
            })
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        id: { type: [Number], default: null }
    },
}
</script>